import { initializeApp } from 'firebase/app';
import { getToken, getMessaging, onMessage, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyDWII8OywWZHmUVjvnb5KzLRpg9A3Fy17s",
  authDomain: "focus-copilot-283506.firebaseapp.com",
  databaseURL: "https://focus-copilot-283506.firebaseio.com",
  projectId: "focus-copilot-283506",
  storageBucket: "focus-copilot-283506.appspot.com",
  messagingSenderId: "642049577891",
  appId: "1:642049577891:web:64b9c0c68409e77ab9c016"
};

//console.log('*** Environment ***', process.env.REACT_APP_ENV)
//console.log('*** Firebase Config ***', firebaseConfig)

let messaging = undefined;
(async () => {
  console.log("Before initialize firebase");
  const isBrowserFirebaseMessagingSupport = await isSupported();
  console.log("After initialize firebase");
  if(isBrowserFirebaseMessagingSupport){
    const firebaseApp = initializeApp(firebaseConfig);
    messaging = getMessaging(firebaseApp);
  }
  else
    console.log('initialize: Firebase messaging is not supported');
})();

async function getOrRegisterServiceWorker() {
  console.log("Before getOrRegisterServiceWorker");
  const isBrowserFirebaseMessagingSupport = await isSupported();
  console.log("After getOrRegisterServiceWorker");

    if (isBrowserFirebaseMessagingSupport && 'serviceWorker' in navigator) {
      return window.navigator.serviceWorker
        .getRegistration('/firebase-push-notification-scope')
        .then((serviceWorker) => {
          if (serviceWorker) return serviceWorker;
          return window.navigator.serviceWorker.register('/firebase-messaging-sw.js', {
            scope: '/firebase-push-notification-scope',
          });
        });
    }
    else
      console.log('getOrRegisterServiceWorker: The browser doesn`t support firebase or service worker or both.');
}

export async function getFirebaseToken() {
  console.log("Before getFirebaseToken");
  const isBrowserFirebaseMessagingSupport = await isSupported();
  console.log("After getFirebaseToken");

  if(isBrowserFirebaseMessagingSupport){
    return getOrRegisterServiceWorker()
      .then((serviceWorkerRegistration) =>
        getToken(messaging, { vapidKey: 'BO0YssQAj6ho2us66iun5v4Q-fv-uKK_Jml0lEipEzQg-t_jpw8z7D3N-LEI9s6i6XYMn1YvAs8CVkyTwlMDboA', serviceWorkerRegistration }));
  }
  else
    console.log('getFirebaseToken: Firebase messaging is not supported');
}

export const onForegroundMessage = () =>
  new Promise((resolve) => onMessage(messaging, (payload) => resolve(payload)));

